"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatewayTimeoutError = exports.BadGatewayError = exports.InternalServerError = exports.NotFoundError = exports.InvalidRefreshTokenError = exports.NotAllowedError = exports.IdentityDisabledError = exports.PasswordRevokedError = exports.InvalidParameterError = exports.GenericError = void 0;
const core_1 = require("@smash-sdk/core");
class GenericError extends core_1.SDKError {
}
exports.GenericError = GenericError;
class InvalidParameterError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidParameterError";
    }
}
exports.InvalidParameterError = InvalidParameterError;
class PasswordRevokedError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "PasswordRevokedError";
    }
}
exports.PasswordRevokedError = PasswordRevokedError;
class IdentityDisabledError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "IdentityDisabledError";
    }
}
exports.IdentityDisabledError = IdentityDisabledError;
class NotAllowedError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "NotAllowedError";
    }
}
exports.NotAllowedError = NotAllowedError;
class InvalidRefreshTokenError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidRefreshTokenError";
    }
}
exports.InvalidRefreshTokenError = InvalidRefreshTokenError;
class NotFoundError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "NotFoundError";
    }
}
exports.NotFoundError = NotFoundError;
class InternalServerError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InternalServerError";
    }
}
exports.InternalServerError = InternalServerError;
class BadGatewayError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "BadGatewayError";
    }
}
exports.BadGatewayError = BadGatewayError;
class GatewayTimeoutError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "GatewayTimeoutError";
    }
}
exports.GatewayTimeoutError = GatewayTimeoutError;
exports.default = {
    GenericError,
    InvalidParameterError,
    PasswordRevokedError,
    IdentityDisabledError,
    NotAllowedError,
    InvalidRefreshTokenError,
    NotFoundError,
    InternalServerError,
    BadGatewayError,
    GatewayTimeoutError,
};
